import type { PopulatedItem } from '@game/game-data';

export function getDisplayName(item: PopulatedItem, quality: number): string {
  return `${item.qualityAdjectives[quality]} ${item.name}`;
}
